/*
 * Minimal PDP countdown line.
 * Re-queries the DOM every tick. Do not cache a NodeList.
 */
(function () {
  if (window.__cbPdpCountdownInit) return;
  window.__cbPdpCountdownInit = true;

  var intervalId = null;

  function pad(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  function format(leftMs) {
    var t = Math.floor(Math.max(0, leftMs) / 1000);
    return Math.floor(t / 86400) + 'd ' + pad(Math.floor((t % 86400) / 3600)) + 'h ' + pad(Math.floor((t % 3600) / 60)) + 'm';
  }

  function onSale(variant) {
    if (!variant) return false;
    var compare = Number(variant.compare_at_price);
    var price = Number(variant.price);
    return compare > 0 && compare > price;
  }

  function inEditor() {
    return window.Shopify && Shopify.designMode;
  }

  function paint(el) {
    if (!el || !el.isConnected) return;
    if (el.dataset.cbDone === 'true') return;

    if (el.dataset.cbShowOnlyOnSale === 'true' && el.dataset.cbOnSale === 'false' && !inEditor()) {
      el.hidden = true;
      return;
    }

    var out = el.querySelector('[data-cb-t]');
    var target = new Date(el.dataset.cbDeadline).getTime();
    if (!out || isNaN(target)) {
      el.hidden = true;
      el.dataset.cbDone = 'true';
      return;
    }

    var left = target - Date.now();
    if (left <= 0) {
      if (el.dataset.cbExpired) {
        if (out.textContent !== el.dataset.cbExpired) out.textContent = el.dataset.cbExpired;
        var dot = el.querySelector('.cb-cdline__dot');
        if (dot) dot.style.display = 'none';
        el.hidden = false;
      } else {
        el.hidden = true;
      }
      el.dataset.cbDone = 'true';
      return;
    }

    var next = format(left);
    if (out.textContent !== next) out.textContent = next;
    if (el.hidden) el.hidden = false;
  }

  function paintAll() {
    document.querySelectorAll('[data-cb-line]').forEach(paint);
  }

  function applyVariant(variant) {
    document.querySelectorAll('[data-cb-line]').forEach(function (el) {
      if (el.dataset.cbShowOnlyOnSale === 'true') {
        el.dataset.cbOnSale = onSale(variant) ? 'true' : 'false';
      }
    });
    paintAll();
  }

  function startInterval() {
    if (intervalId) return;
    intervalId = setInterval(paintAll, 1000);
  }

  function stopInterval() {
    if (!intervalId) return;
    clearInterval(intervalId);
    intervalId = null;
  }

  function init() {
    paintAll();
    if (document.querySelector('[data-cb-line]')) startInterval();
    else stopInterval();
  }

  init();

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
  document.addEventListener('shopify:block:select', paintAll);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) paintAll();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      applyVariant(event && event.data && event.data.variant);
    });
  }

  document.addEventListener('lpc:variant:change', function (event) {
    applyVariant(event.detail && event.detail.variant);
  });
  document.addEventListener('lpc:variant-change', function (event) {
    applyVariant(event.detail && event.detail.variant);
  });
})();
